/**
 * Application Configuration
 *
 * Centralized configuration for environment variables and feature flags
 */

/**
 * Check if MongoDB mode is enabled
 * When true, the app uses MongoDB for menu items and hides PostgreSQL-specific UI
 */
export const isMongoDBMode = (): boolean => {
  return import.meta.env.VITE_USE_MONGODB === 'true'
}

/**
 * API Configuration
 */
export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  apiPrefix: import.meta.env.VITE_API_PREFIX || 'api',
  aiServiceUrl: import.meta.env.VITE_AI_SERVICE_URL || 'https://waitergpt-botstack-q9oh.onrender.com',

  // Database mode
  useMongoDb: isMongoDBMode(),

  // App info
  appName: import.meta.env.VITE_APP_NAME || 'WaiterGPT',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',

  // Development
  enableDevTools: import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true',

  // WebRTC
  useWebRTC: import.meta.env.VITE_USE_WEBRTC === 'true',
} as const

export default config
